import { Component, OnInit } from "@angular/core";
import {
	UntypedFormControl,
	UntypedFormGroup,
	Validators
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UserDTO, VerifyPasswordRecoveryDTO } from "@shared/model/user.model";
import { UserApiService } from "@shared/services/users/userApi.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-change-password",
	templateUrl: "./change-password.component.html",
	styleUrl: "./change-password.component.scss",
	standalone: false
})
export class ChangePasswordComponent implements OnInit {
	changePasswordForm: UntypedFormGroup = new UntypedFormGroup({
		password: new UntypedFormControl("", [
			Validators.required,
			Validators.minLength(8)
		]),
		confPassword: new UntypedFormControl("", [
			Validators.required,
			Validators.minLength(8)
		])
	});

	user: UserDTO;
	tag: string;
	username: string;
	email: string;

	constructor(
		private userService: UserApiService,
		public utils: ClickarUtilsService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		public wcmService: WcmService
	) { }

	ngOnInit() {
		this.activatedRoute.queryParams.subscribe(value => {
			this.tag = value["tag"];
			this.username = value["username"];
			this.email = value["email"];

			if (
				this.utils.isNullOrUndefined(this.tag) ||
				this.utils.isNullOrUndefined(this.username)
			) {
				this.router.navigate(["/"]);
				return;
			}
		});
	}

	changePassword() {
		if (
			this.utils.isNullOrUndefined(this.tag) ||
			this.utils.isNullOrUndefined(this.username)
		) {
			this.router.navigate(["/"]);
			return;
		}

		const dto: VerifyPasswordRecoveryDTO =
			this.changePasswordForm.getRawValue();
		dto.hash = this.tag;
		dto.username = this.username;

		this.userService.verifyPasswordRecoveryUsingPOST(dto).subscribe(() => {
			this.router.navigate(["/"]);
		});
	}

	isValid() {
		const regex = [
			/[a-z]+/g,
			/[A-Z]+/g,
			/[.@"£%$!%*?&/()=^§,.\-_#°\\\|]+/g,
			/[0-9]+/g
		],
			regex1 = [
				/[a-z]+/g,
				/[A-Z]+/g,
				/[.@"£%$!%*?&/()=^§,.\-_#°\\\|]+/g,
				/[0-9]+/g
			],
			pass = this.changePasswordForm.controls["password"].value,
			confPass = this.changePasswordForm.controls["confPassword"].value;

		console.log(pass);
		console.log(confPass);
		// console.log("pass",regex.map(l => l.test(pass)));
		// console.log("confpass",regex1.map(l => l.test(confPass)));
		if (
			regex.map(l => +!!l.test(pass)).filter(value => value).length >= 3 &&
			regex1.map(l => +!!l.test(confPass)).filter(value => value).length >= 3 &&
			pass == confPass
		) {
			console.log(true);
			return true;
		}

		return false;
	}
}
